import { render } from "./Quicklinks.vue?vue&type=template&id=27701bfc&scoped=true"
import script from "./Quicklinks.vue?vue&type=script&lang=js"
export * from "./Quicklinks.vue?vue&type=script&lang=js"

import "./Quicklinks.vue?vue&type=style&index=0&id=27701bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27701bfc"]])

export default __exports__